/**
 * Re-export shared appointment service so web + native import the same implementation.
 * Real ADHA Basic Auth APIs live in `@/core/api/services/appointmentService`.
 */
export {
  appointmentService,
  AppointmentService,
  mapSlotTimesFromResponse,
  extractUpcomingAppointment,
  extractAppointmentIdFromMutationResponse,
  extractEventIdFromMutationResponse,
  assertAppointmentApiSuccess,
  toAppointmentDateId,
  formatAppointmentTimeLabel,
} from '@/core/api/services/appointmentService';
